import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ArrowRight } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";
import { Logo } from "../brand/Logo";
import { NAV_LINKS } from "../../config/site";
import { ROUTES } from "../../config/routes";
import { CtaLink } from "../common/CtaLink";

const linkClass = ({ isActive }) =>
  `rounded-md px-3 py-2 text-sm font-medium transition-colors focus-ring ${isActive ? "text-slate-50" : "text-slate-400 hover:text-slate-100"}`;

const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button data-testid="nav-mobile-toggle" aria-label="Open menu" className="grid h-11 w-11 place-items-center rounded-lg border border-white/10 text-slate-200 lg:hidden focus-ring">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[86%] max-w-sm border-white/10 bg-[#07080C] text-slate-100">
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <nav aria-label="Mobile" className="mt-10 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end data-testid={`mobile-${l.testId}`} onClick={() => setOpen(false)}
              className={({ isActive }) => `rounded-lg px-4 py-4 font-display text-xl font-semibold ${isActive ? "bg-white/5 text-white" : "text-slate-300"}`}>
              {l.label}
            </NavLink>
          ))}
          <NavLink to={ROUTES.OWNER_LOGIN} data-testid="mobile-nav-owner-login" onClick={() => setOpen(false)} className="rounded-lg px-4 py-4 font-display text-xl font-semibold text-slate-300">Owner Login</NavLink>
          <CtaLink to={ROUTES.PRICING} testId="mobile-nav-cta-get-carlink" className="mt-6 justify-center" onClick={() => setOpen(false)}>
            Get CARLINK <ArrowRight className="h-4 w-4" />
          </CtaLink>
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export const SiteHeader = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#07080C]/85 backdrop-blur-xl">
    <div className="container-x flex h-16 items-center justify-between lg:h-[72px]">
      <Logo />
      <nav aria-label="Main" className="hidden items-center gap-1 lg:flex">
        {NAV_LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} end data-testid={l.testId} className={linkClass}>{l.label}</NavLink>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <Link to={ROUTES.OWNER_LOGIN} data-testid="nav-owner-login" className="hidden rounded-md px-3 py-2 text-sm font-semibold text-slate-300 hover:text-white focus-ring md:inline-flex">Owner Login</Link>
        <CtaLink to={ROUTES.PRICING} testId="nav-cta-get-carlink" className="hidden sm:inline-flex !px-5 !py-2.5">Get CARLINK</CtaLink>
        <MobileMenu />
      </div>
    </div>
  </header>
);
